var FMValidationPin = {
    version: '1.0',
    author: 'CAA Digital',
    project: 'Family Membership',
    Date: 'May 2020',

    //initialization 
    init: function () {
        var context = this;
        //Global variables
        context.config = {
            textboxEnterPin: document.getElementById("textbox_enter_pin"),
            checkboxTermsConditions: document.getElementById("checkbox_terms_conditons"),
            buttonActivate: document.getElementById("button_activate"),
            copyValidationNotification: document.querySelector(".validation-box__notification-copy"),
            containerValidationNotification: document.querySelector(".validation-box__notification"),
            blockPageError: document.querySelector('.page-error-block__pin'),
            spanPageErrorCount: document.querySelector('#page_error_count'),
        };

        //Call DOM invoking functions here
        context.onDomReady();
        context.eventHandlers();

    },

    onDomReady: function () {
        var context = this;

        //Load all functions

    },

    //Handle all page level events
    eventHandlers: function () {
        var context = this;

        // Personal details page level error messages
        var errorBlock = context.config.blockPageError,
            errorCount = context.config.spanPageErrorCount,
            parsleyErrorArray = [];

        if (context.config.blockPageError) {

            //On Parsley form error event show the red 
            //error box and re-attach aria attributes 
            window.Parsley.on('form:error', function () {
                errorBlock.classList.remove("d-none");
                //$(".validation__summary-copy").attr("role", "alert");
                jQuery(".validation__summary-copy").attr("aria-live", "assertive");
            });

            //On Parsley field validated(fires AFTER field is validated) event 
            //create an array of error fields 
            window.Parsley.on('field:validated', function (fieldInstance) {
                if (fieldInstance.$element[0].previousSibling.parentNode.getAttribute("class").indexOf("input__checkbox-container") >= 0) {
                    if(fieldInstance.$element[0].previousSibling.parentNode.getAttribute("class").indexOf("parsley-error") >= 0){
                        parsleyErrorArray.push(fieldInstance.$element);
                    }
                }
                else{   
                    if (fieldInstance.$element[0].className.indexOf('parsley-error')>= 0) {
                        parsleyErrorArray.push(fieldInstance.$element);
                    }
                }
                
            });

            //On parsley form validate(fires BEFORE form is validated) event 
            //reset the error array so the error messges don't stack up 
            window.Parsley.on('form:validate', function () {
                parsleyErrorArray.length = 0;
            });

            //On parsley form validate(fires BEFORE form is validated) event 
            //append the error messages onto page
            window.Parsley.on('form:validated', function () {
                //clear the hash so that it focuses error block every time form is submitted 
                window.location.hash = "";
                var errorListDiv = document.getElementById("page_error_list");
                errorListDiv.innerHTML = "";
                for (var i = 0; i < parsleyErrorArray.length; i++) {
                    errorListDiv.innerHTML += "<li><span>Error " + (i + 1) + ": </span><span><a href='#" + parsleyErrorArray[i][0].id + "'>" + parsleyErrorArray[i][0].dataset.parsleyRequiredMessage + "</a></span>" + (parsleyErrorArray[i][0].hasAttribute('data-format') ? "<span> (Format: " + parsleyErrorArray[i][0].getAttribute('data-format') + ")</span>" : '') + "</li>";
                }
                noOfErrors = parsleyErrorArray.length;
                errorCount.innerHTML = noOfErrors;
                //Focus error block on submit 
                window.location.hash = "#page_error_block";
            });

            //On field success event remove the aria attributes
            window.Parsley.on('field:success', function () {
                jQuery(".validation__summary-copy").removeAttr("role", "alert");
                jQuery(".validation__summary-copy").removeAttr("aria-live");
            });

            //On form success event hide the red error message block
            window.Parsley.on('form:success', function () {
                errorBlock.classList.add("d-none");
            });
        }


    },
};

window.addEventListener("load", function () {
    FMValidationPin.init();
});

